import { render, staticRenderFns } from "./table.vue?vue&type=template&id=79cfac25&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79cfac25')) {
      api.createRecord('79cfac25', component.options)
    } else {
      api.reload('79cfac25', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=79cfac25&", function () {
      api.rerender('79cfac25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gen/table.vue"
export default component.exports